import { makeStyles } from '@material-ui/core/styles';
import { Color } from '@sunrun/mui-theme';
import { ERROR_COLOR } from './constants/_colors';

const useStyles = makeStyles(() => ({
  defaultColors: {
    '& .MuiFormHelperText-root': {
      color: 'inherit',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: `${Color.BLACK_45} !important`,
    },
  },
  successColors: {
    '& .MuiFormHelperText-root': {
      color: `${Color.PRIMARY_BLUE}`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: `${Color.PRIMARY_BLUE} !important`,
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: `${Color.BLACK_45} !important`,
    },
  },
  warningColors: {
    '& .MuiFormHelperText-root': {
      color: `${ERROR_COLOR}`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: `${ERROR_COLOR} !important`,
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: `${Color.BLACK_45} !important`,
    },
  },
  errorIcon: {
    paddingRight: '0px',
    color: `${ERROR_COLOR}`,
  },
  successIcon: {
    paddingRight: '0px',
    color: `${Color.PRIMARY_BLUE}`,
  },
}));

export { useStyles };
